import React, { FC } from "react";
import { toggleSideMenu, useIsMenuOpen } from "src/components/side-menu/side-menu-store";
import HamburgerIcon from "src/components/icons/HamburgerIcon.svg";
import HamburgerIconWithMargin from "src/components/icons/HamburgerIconWithMargin.svg";
import ActiveHamburgerIcon from "src/components/icons/Arrow.inline.svg";
import ActiveHamburgerIconWithMargin from "src/components/icons/ArrowIconWithMargin.inline.svg";

interface ISideMenuButtonProps {
  className?: string;
}

const SideMenuButton: FC<ISideMenuButtonProps> = ({ className }) => {
  const isMenuOpen = useIsMenuOpen()

  const handleClick = () => {
    toggleSideMenu();
  };

  const borderIfActive = isMenuOpen
    ? "border-navyBlueGray"
    : "border-transparent";
  const darkBackgroundIfActive = isMenuOpen ? "bg-almostBlackBlue" : "";
  const verticalPadding = isMenuOpen ? "py-3" : "py-3.5";
  const paddingRight = isMenuOpen ? "" : "pr-1.5";

  return (
    <div
      className={`self-stretch flex items-center transition duration-300 linear h-full lg:border-b ${borderIfActive} ${className}`}>
      <button
        onClick={handleClick}
        className={`flex items-center justify-center w-14 sm:hidden ${paddingRight} ${verticalPadding} ${darkBackgroundIfActive}`}
        type='button'>
        <div className='flex justify-center flex-wrap box-border'>
          {!isMenuOpen && (
            <img src={HamburgerIcon} alt='Toggle Side Menu' className='h-7' />
          )}
          {isMenuOpen && (
            <ActiveHamburgerIcon
              alt='Toggle Side Menu'
              className='h-8 transform rotate-180 lg:rotate-0 text-appGreen'
            />
          )}
        </div>
      </button>
      <button
        onClick={handleClick}
        className={`hidden items-center justify-center w-14 sm:flex ${darkBackgroundIfActive}`}
        type='button'>
        <div className='flex justify-center flex-wrap box-border'>
          {!isMenuOpen && (
            <img
              src={HamburgerIconWithMargin}
              alt='Toggle Side Menu'
              className='h-14'
            />
          )}
          {isMenuOpen && (
            <ActiveHamburgerIconWithMargin
              alt='Toggle Side Menu'
               className='h-14 transform rotate-180 lg:rotate-0 text-appGreen mt-0'
            />
          )}
        </div>
      </button>
    </div>
  );
};

export default SideMenuButton;
